import { Component, Input } from '@angular/core';
import { TooltipPlacement, TooltipSize } from '@mode/capra';

@Component({
  template: '',
})
export abstract class BaseNotebookCellButtonComponent {
  @Input()
  cellToken!: string;

  toolTipPlacement: TooltipPlacement = 'bottom';
  tooltipSize: TooltipSize = 'mini';
}
